import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

defineComponent({
  tag: "oc-focused-dialog-v1",
  styles: () => import("./FocusedDialogV1.global.scss?inline"),
  props: {
    inApp: { type: "Boolean", reflect: true },
    headline: { reflect: true },
    headlineLevel: { type: "Number", attribute: "headline-level" },
    closeUrl: { type: "String", attribute: "close-url", reflect: true },
    prevUrl: { type: "String", attribute: "prev-url", reflect: true },
    showBackButton: { type: "Boolean", attribute: "show-back-button", reflect: true },
  },
  component: () => import("./FocusedDialogV1.svelte"),
});
